import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICachedEntitiesSlice } from './types';

const initialState: ICachedEntitiesSlice = {
  cachedCohort: null,
  cachedFunnel: null,
  nextStep: null,
  replaceReport: null,
  createNewReport: null,
};

export default createSlice({
  name: 'cachedEntities',
  initialState,
  reducers: {
    setCachedCohort: (
      draft,
      action: PayloadAction<ICachedEntitiesSlice['cachedCohort']>,
    ) => {
      draft.cachedCohort = action.payload;
    },
    setCachedFunnel: (
      draft,
      action: PayloadAction<ICachedEntitiesSlice['cachedFunnel']>,
    ) => {
      draft.cachedFunnel = action.payload;
    },
    setNextStep: (
      draft,
      action: PayloadAction<ICachedEntitiesSlice['nextStep']>,
    ) => {
      draft.nextStep = action.payload;
    },
    clearCachedCohort: (draft) => {
      draft.cachedCohort = null;
    },
    clearCachedFunnel: (draft) => {
      draft.cachedFunnel = null;
    },
    clearNextStep: (draft) => {
      draft.nextStep = null;
    },
    setReplaceReport: (
      draft,
      action: PayloadAction<ICachedEntitiesSlice['replaceReport']>,
    ) => {
      draft.replaceReport = action.payload;
    },
    clearReplaceReport: (draft) => {
      draft.replaceReport = null;
    },
    setCreateNewReport: (
      draft,
      action: PayloadAction<ICachedEntitiesSlice['createNewReport']>,
    ) => {
      draft.createNewReport = action.payload;
    },
    clearCreateNewReport: (draft) => {
      draft.createNewReport = null;
    },
  },
});
